import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material"
import { alpha } from "@mui/material/styles"

interface DeleteScopeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onScopeSelect: (scope: "this" | "all") => void
}

export function DeleteScopeDialog({
  open,
  onOpenChange,
  onScopeSelect,
}: DeleteScopeDialogProps) {
  return (
    <Dialog open={open} onClose={() => onOpenChange(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Recurring Task</DialogTitle>
      <DialogContent>
        <DialogContentText>
          What would you like to delete?
        </DialogContentText>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, py: 2 }}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => onScopeSelect("this")}
            sx={{
              justifyContent: "flex-start",
              textAlign: "left",
              height: "auto",
              py: 2,
              px: 2,
              whiteSpace: "normal",
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontWeight: 600 }}>Only this occurrence</Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Other occurrences will continue
              </Typography>
            </Box>
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => onScopeSelect("all")}
            sx={{
              justifyContent: "flex-start",
              textAlign: "left",
              height: "auto",
              py: 2,
              px: 2,
              whiteSpace: "normal",
              borderColor: (t) => alpha(t.palette.error.main, 0.3),
              "&:hover": {
                bgcolor: (t) => alpha(t.palette.error.main, 0.06),
                borderColor: (t) => alpha(t.palette.error.main, 0.5),
              },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontWeight: 600, color: "error.main" }}>Delete entire series</Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Takes all occurrences off the lists; the series is kept
              </Typography>
            </Box>
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
